import { useQuery } from "@tanstack/react-query";
import { getTariffs } from "../../../api/request/getTariffs";
import { TARIFFS_QUERY_KEYS } from "../../constants";

export const useGetTariffs = () => {
  const query = useQuery({
    queryKey: [TARIFFS_QUERY_KEYS.getTariffs],
    queryFn: () => getTariffs(),
  });

  return query;
};
